import React, { useEffect, useState } from 'react'
import Header from '../master/SideBar'
import Nav from '../master/NavBar'
import { getSessions } from '../../api/SessionsService';
import { StaffList } from '../../api/Staff';
import { ToastMain,SweetAlertShow } from '../master/Master';
import { getstaffwithid } from '../../api/FacultyService';
import { imgBaseUrl } from '../../api/api';
import StaffHeader from './StaffHeader';

const SalarySlip = () => {
    const instituteData = JSON.parse(localStorage.getItem("setting")) || {};
    const [loading, setLoading] = useState(false);
    const [type, setType] = useState('');
    const [session, setSession] = useState('');
    const [selectedSession, setSelectedSession] = useState('');
    const [staff, setStaff] = useState([]);
    const [selectedStaff, setSelectedStaff] = useState('');
    const [experience, setExperience] = useState('');
    const [classLevel, setClassLevel] = useState('');
    const [singleStaff, setSingleStaff] = useState('');


    const getSession = async () => {
        setLoading(true);
        try {
            const response = await getSessions();
            if (response?.data?.status) {
                const ActiveSession = response?.data?.data?.find((s) => s?.status == '1')
                setSession(response?.data);
                setSelectedSession(ActiveSession?.id)
            } else {
                // ToastMain.fire({
                //     icon: 'info',
                //     title: response?.data?.messsage || 'something went wrong'
                // })
                SweetAlertShow('info','Warning', response?.data?.messsage )
            }
        } catch (error) {
            SweetAlertShow('error','Error', error?.response?.data?.messsage ?? error?.messsage)
            // ToastMain.fire({
            //     icon: 'error',
            //     title: error?.response?.data?.messsage || 'something went wrong'
            // })
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        getSession();

    }, [])

    const getStaff = async () => {
        setLoading(true)
        const addUrl = `&session_id=${selectedSession}`
        try {
            const response = await StaffList(addUrl);
            if (response?.data?.status) {
                setStaff(response?.data?.data || [])
            } else {
                // ToastMain.fire({
                //     icon: 'info',
                //     title: response?.data?.messsage || 'something went wrong'
                // })
                SweetAlertShow('info','Warning',response?.data?.messsage )
            }
        } catch (error) {
            // ToastMain.fire({
            //     icon: 'error',
            //     title: error?.response?.data?.messsage || 'something went wrong'
            // })

            SweetAlertShow('error','Error',error?.response?.data?.messsage ?? error?.messsage)

        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (selectedSession) {
            getStaff();
        }
    }, [selectedSession]);

    const StaffById = async (selectedStaff) => {
        setLoading(true);
        // const addUrl = `id=${selectedStaff}`
        try {
            const response = await getstaffwithid(selectedStaff);
            if (response?.data?.status) {
                setSingleStaff(response?.data?.data || []);
            } else {
                // ToastMain.fire({
                //     icon: 'info',
                //     title: response?.data?.messsage || 'something went wrong'
                // })

                SweetAlertShow('info','Warning',response?.data?.messsage)
            }
        } catch (error) {
            // ToastMain.fire({
            //     icon: 'error',
            //     title: error?.response?.data?.messsage || 'something went wrong'
            // })

            SweetAlertShow('error','Error',error?.response?.data?.messsage ?? error?.messsage)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        if (selectedStaff) {
            StaffById(selectedStaff)
        }
    }, [selectedStaff]);

 const handlePrintCertificate = (staff, instituteData, type, experience, classLevel, imgBaseUrl) => {
    const printWindow = window.open("", "_blank");

    // Date format
    const currentMonth = new Date().toLocaleDateString("en-IN", {
        month: "long",
        year: "numeric",
    });

    printWindow.document.write(`
<html>
<head>
<title>Salary Slip</title>

<style>
  body {
    font-family: Arial, sans-serif;
    margin: 40px;
    background: #fff;
    color: #000;
  }

  .slip-box {
    border: 1px solid #ccc;
    padding: 30px;
  }

  .header {
    text-align: center;
    margin-bottom: 20px;
  }

  .header img {
    width: 80px;
    margin-bottom: 10px;
  }

  .inst-name {
    font-size: 22px;
    font-weight: bold;
  }

  .sub-info {
    font-size: 14px;
    margin: 2px 0;
  }

  .title {
    font-size: 18px;
    font-weight: bold;
    margin: 15px 0;
    text-decoration: underline;
    text-align: center;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
    margin-top: 15px;
  }

  table, td, th {
    border: 1px solid #ccc;
  }

  td, th {
    padding: 8px;
  }

  .info-table td {
    border: none;
  }

  .in-words {
    margin-top: 20px;
    font-weight: bold;
  }

  .note {
    font-size: 12px;
    margin-top: 8px;
    color: #444;
  }

  .sign-area {
    margin-top: 40px;
    text-align: right;
    font-weight: bold;
  }

  @media print {
    body { margin: 20px; }
  }
</style>

</head>
<body>

<div className="slip-box">

  <!-- HEADER -->
  <div className="header">
    <img src="${instituteData?.logo_img ? `${imgBaseUrl}${instituteData.logo_img}` : "/files/logo.png"}" />
    <div className="inst-name">${instituteData?.name}</div>
    <div className="sub-info">${instituteData?.address}</div>
    <div className="sub-info">Contact: ${instituteData?.phone} | ${instituteData?.email}</div>
    <div className="title">Salary Slip for the Month of ${currentMonth}</div>
  </div>

  <!-- EMPLOYEE INFO -->
  <table className="info-table">
    <tr>
      <td><b>Employee ID:</b></td>
      <td>${staff?.registration_no || ""}</td>

      <td><b>Employee Name:</b></td>
      <td>${staff?.name}</td>
    </tr>

    <tr>
      <td><b>Date of Joining:</b></td>
      <td>${staff?.join_date ? new Date(staff.join_date).toLocaleDateString("en-IN") : ""}</td>

      <td><b>Designation:</b></td>
      <td>${
        type === "teacher"
          ? "Teacher"
          : type === "driver"
          ? "Driver"
          : type === "accountant"
          ? "Accountant"
          : type === "computer"
          ? "Computer Operator"
          : "Staff Member"
      }</td>
    </tr>

    <tr>
      <td><b>Bank Name:</b></td>
      <td>${staff?.bank_name || "--------"}</td>

      <td><b>Account Number:</b></td>
      <td>${staff?.account_no || "--------"}</td>
    </tr>
  </table>

  <!-- EARNINGS + DEDUCTIONS -->
  <table>
    <thead>
      <tr style="text-align:center; font-weight:bold;">
        <th colspan="2">Earnings</th>
        <th colspan="2">Deductions</th>
      </tr>
    </thead>

    <tbody>
      <tr>
        <td><b>Description</b></td>
        <td><b>Amount (₹)</b></td>
        <td><b>Description</b></td>
        <td><b>Amount (₹)</b></td>
      </tr>

      <tr>
        <td>Basic</td>
        <td>${staff?.basic_salary || 0}</td>
        <td>Provident Fund</td>
        <td>${staff?.pf || 0}</td>
      </tr>

      <tr>
        <td>HRA</td>
        <td>${staff?.hra_allowance || 0}</td>
        <td>Professional Tax</td>
        <td>${staff?.professional_tax || 0}</td>
      </tr>

      <tr>
        <td>LTA</td>
        <td>${staff?.lta || 0}</td>
        <td>TDS</td>
        <td>${staff?.tds || 0}</td>
      </tr>

      <tr>
        <td>Special Allowance</td>
        <td>${staff?.special_allowance || 0}</td>
        <td>Other Deductions</td>
        <td>${staff?.other_deductions || 0}</td>
      </tr>

      <tr style="font-weight:bold; background:#f5f5f5;">
        <td>Gross Earnings</td>
        <td>${staff?.gross_earnings || 0}</td>
        <td>Gross Deductions</td>
        <td>${staff?.gross_deductions || 0}</td>
      </tr>

      <tr style="font-weight:bold; background:#e7f4e4;">
        <td>Net Salary</td>
        <td>${staff?.net_salary || 0}</td>
        <td></td>
        <td></td>
      </tr>
    </tbody>
  </table>

  <!-- IN WORDS -->
  <div className="in-words">
    In Words: ${staff?.salary_in_words || "_________"}
  </div>

  <div className="note">*This is a system generated payslip, signature not required.</div>

  <div className="sign-area">Authorized Signatory</div>

</div>

<script>
  window.print();
  window.onafterprint = function () {
    window.close();
  };
</script>

</body>
</html>
`);

    printWindow.document.close();
};







    return (
        <>
            {loading && (
                <div
                    className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
                    style={{ zIndex: 9999 }}
                >
                    <div className="sk-chase sk-primary display-1">
                        <div className="sk-chase-dot" />
                        <div className="sk-chase-dot" />
                        <div className="sk-chase-dot" />
                        <div className="sk-chase-dot" />
                        <div className="sk-chase-dot" />
                        <div className="sk-chase-dot" />
                    </div>
                </div>
            )}
            <div className="layout-wrapper layout-content-navbar">
                <div className="layout-container">
                    <Header />
                    <div className="layout-page">
                        <Nav />

                        <div className="container-fluid mt-2">
                            <div className="row">
                                <div className="d-flex gap-2">
                                    <div className="col-md-3">
                                        <StaffHeader data={'Staff Portal'} />
                                    </div>

                                    <div className="col-md-9">
                                        <div className="card">
                                            <div className="card-body">
                                                <h3>Salary Slip</h3>
                                                <div className="row">
                                                    {/* <pre>{JSON.stringify(staff, null, 2)}</pre> */}
                                                    <div className="col-md-3">
                                                        <div className="form-floating form-floating-outline">
                                                            <select className='form-select' name="staff_id" id="staff" value={selectedStaff} onChange={(e) => {
                                                                setSelectedStaff(e.target.value)
                                                            }}>
                                                                <option>
                                                                    Select Staff
                                                                </option>
                                                                {staff?.map((item, index) => (
                                                                    <option key={item?.id} value={item?.id}>
                                                                        {item?.name} : ({item?.staff_type})
                                                                    </option>
                                                                ))}
                                                                <label htmlFor="staff">Select Staff</label>
                                                            </select>
                                                        </div>
                                                    </div>



                                                </div>
                                            </div>
                                        </div>
                                        <div className="card mt-3">
                                            <div className="card-body">
                                                <div className="col-md-9 mx-auto">

                                                    {singleStaff && (
                                                        <div
                                                            className="p-4 shadow rounded"
                                                            style={{
                                                                background: "#fff",
                                                                color: "#000",
                                                                fontFamily: "Arial, sans-serif",
                                                                fontSize: "14px",
                                                                border: "1px solid #ccc",
                                                            }}
                                                        >

                                                            {/* HEADER */}
                                                            <div className="text-center mb-4">
                                                                <img
                                                                    src={
                                                                        instituteData?.logo_img
                                                                            ? `${imgBaseUrl}${instituteData.logo_img}`
                                                                            : "/files/logo.png"
                                                                    }
                                                                    alt="logo"
                                                                    style={{ width: 80, marginBottom: 10 }}
                                                                />

                                                                <h4 style={{ fontWeight: "bold", margin: 0 }}>{instituteData?.name}</h4>
                                                                <p style={{ margin: 0 }}>{instituteData?.address}</p>
                                                                <p style={{ margin: 0 }}>
                                                                    Contact: {instituteData?.phone} | {instituteData?.email}
                                                                </p>

                                                                <h5 className="mt-3" style={{ fontWeight: "bold" }}>
                                                                    Salary Slip for the Month of{" "}
                                                                    {new Date().toLocaleDateString("en-IN", {
                                                                        month: "long",
                                                                        year: "numeric",
                                                                    })}
                                                                </h5>
                                                            </div>

                                                            {/* EMPLOYEE INFO GRID */}
                                                            <div className="row mb-4" style={{ lineHeight: 1.6 }}>
                                                                <div className="col-6 border-end">
                                                                    <p><b>Employee ID:</b> {singleStaff?.registration_no}</p>
                                                                    <p><b>Date of Joining:</b> {singleStaff?.join_date && new Date(singleStaff?.join_date).toLocaleDateString("en-IN")}</p>
                                                                    <p><b>Department:</b> Teaching Staff</p>
                                                                    <p><b>Designation:</b>
                                                                        {type === "teacher"
                                                                            ? "Teacher"
                                                                            : type === "driver"
                                                                                ? "Driver"
                                                                                : type === "accountant"
                                                                                    ? "Accountant"
                                                                                    : "Staff"}
                                                                    </p>
                                                                </div>

                                                                <div className="col-6 ps-4">
                                                                    <p><b>Employee Name:</b> {singleStaff?.name}</p>
                                                                    <p><b>UAN Number:</b> {singleStaff?.uan_no || "--------"}</p>
                                                                    <p><b>Bank Name:</b> {singleStaff?.bank_name || "--------"}</p>
                                                                    <p><b>Account Number:</b> {singleStaff?.account_no || "--------"}</p>
                                                                </div>
                                                            </div>

                                                            {/* EARNINGS + DEDUCTIONS TABLE */}
                                                            <table className="table table-bordered" style={{ fontSize: 14 }}>
                                                                <thead className="text-center">
                                                                    <tr>
                                                                        <th colSpan="2">Earnings</th>
                                                                        <th colSpan="2">Deductions</th>
                                                                    </tr>
                                                                </thead>

                                                                <tbody>
                                                                    <tr>
                                                                        <td>Description</td>
                                                                        <td className="text-end">Amount</td>
                                                                        <td>Description</td>
                                                                        <td className="text-end">Amount</td>
                                                                    </tr>

                                                                    <tr>
                                                                        <td>Basic</td>
                                                                        <td className="text-end">{singleStaff?.basic_salary || 0}</td>
                                                                        <td>Provident Fund</td>
                                                                        <td className="text-end">{singleStaff?.pf || 0}</td>
                                                                    </tr>

                                                                    <tr>
                                                                        <td>HRA</td>
                                                                        <td className="text-end">{singleStaff?.hra_allowance || 0}</td>
                                                                        <td>Professional Tax</td>
                                                                        <td className="text-end">{singleStaff?.professional_tax || 0}</td>
                                                                    </tr>

                                                                    <tr>
                                                                        <td>LTA</td>
                                                                        <td className="text-end">{singleStaff?.lta || 0}</td>
                                                                        <td>TDS</td>
                                                                        <td className="text-end">{singleStaff?.tds || 0}</td>
                                                                    </tr>

                                                                    <tr>
                                                                        <td>Special Allowance</td>
                                                                        <td className="text-end">{singleStaff?.special_allowance || 0}</td>
                                                                        <td>Other Deductions</td>
                                                                        <td className="text-end">{singleStaff?.other_deductions || 0}</td>
                                                                    </tr>

                                                                    <tr style={{ fontWeight: "bold", background: "#f5f5f5" }}>
                                                                        <td>Gross Earnings</td>
                                                                        <td className="text-end">{singleStaff?.gross_earnings || 0}</td>
                                                                        <td>Gross Deductions</td>
                                                                        <td className="text-end">{singleStaff?.gross_deductions || 0}</td>
                                                                    </tr>

                                                                    <tr style={{ fontWeight: "bold", background: "#e7f4e4" }}>
                                                                        <td>Net Pay</td>
                                                                        <td className="text-end">{singleStaff?.net_salary || 0}</td>
                                                                        <td></td>
                                                                        <td></td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>

                                                            {/* IN WORDS */}
                                                            <p className="mt-3">
                                                                <b>In Words: </b> {singleStaff?.salary_in_words || "_________"}
                                                            </p>

                                                            {/* FOOT NOTE */}
                                                            <p style={{ fontSize: 12, color: "#444" }}>
                                                                *This is a system generated payslip, no signature required.
                                                            </p>

                                                            {/* PRINT BUTTON */}
                                                            <div className="text-center mt-4">
                                                                <button
                                                                    className="btn btn-primary"
                                                                    onClick={() =>
                                                                        handlePrintCertificate(
                                                                            singleStaff,
                                                                            instituteData,
                                                                            type,
                                                                            experience,
                                                                            classLevel,
                                                                            imgBaseUrl
                                                                        )
                                                                    }
                                                                >
                                                                    <i className="fa fa-print me-2"></i> Print Salary Slip
                                                                </button>
                                                            </div>

                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default SalarySlip
